import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Container from 'app/components/layout/Container';
import EmptyNavBar from 'app/components/layout/EmptyNavBar';
import Page from 'app/components/layout/Page';
import Button from 'app/components/v2/components/Button';
import Flex from 'app/components/v2/components/Flex';
import Image from 'app/components/v2/components/Image';
import Heading3 from 'app/components/v2/components/Text/Heading3';
import Paragraph from 'app/components/v2/components/Text/Paragraph';

// Local Typings
interface Props {
  alt: string;
  backgroundImage: string;
  backgroundImageLoader?: string;
  heading: string;
  linkAction?: () => void;
  linkTitle?: string;
  subheading: string;
  withNavBar?: boolean;
}

// Local Variables
function redirectToHomePage() {
  // This page might be used outside of Router, so we are doing a hard reload
  window.location.href = window.location.origin;
}

// Component Definition
const ErrorPageUI: FC<Props> = ({
  alt,
  backgroundImage,
  backgroundImageLoader,
  heading,
  linkAction,
  linkTitle,
  subheading,
  withNavBar = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {withNavBar && <EmptyNavBar />}

      <Page
        loading={false}
        title={t('common:errorPage.title', 'Error Page')}
      >
        <Flex
          fullWidth
          justifyContent="center"
        >
          <Container maxWidth="400px">
            <Flex
              flexDirection="column"
              justifyContent="center"
            >
              <Image
                alt={alt}
                loadingImageSrc={backgroundImageLoader}
                src={backgroundImage}
              />
              <Heading3 marginTop={4}>
                {heading}
              </Heading3>

              <Paragraph
                alignment="center"
                marginY={4}
              >
                {subheading}
              </Paragraph>

              {linkTitle && (
                <Button
                  hierarchy="tertiary"
                  onClick={linkAction ?? redirectToHomePage}
                >
                  {linkTitle}
                </Button>
              )}
            </Flex>
          </Container>
        </Flex>
      </Page>
    </>
  );
};

export default ErrorPageUI;
